import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useGroupReservationsSuspenseQuery } from '@mews-commander/core/entities';

export const useReservationContracts = ({ groupId, reservationId }: { groupId: string; reservationId: string }) => {
    const { data: reservationsData } = useGroupReservationsSuspenseQuery(groupId);
    const groupReservationIds = reservationsData.reservations?.map((reservation) => reservation.id);
    const { data: reservationContractsData } = useRepositorySuspenseQuery(
        'reservationUploadedContractFiles',
        'getAll',
        {
            reservationIds: groupReservationIds,
        }
    );
    return reservationContractsData.uploadedContractFiles?.filter((contract) => {
        return contract.reservationId === reservationId;
    });
};
